<template>
  <div class="header__mobile">
    <ul class="header__menu">
      <li
        class="header__item"
        v-if="!isUserManageOnly"
      >
        <NuxtLink
          class="header__link"
          to="/"
          :active-class="mobileLinkActiveClass"
          @click="closeMenu()"
          data-testid="joblist-nav-item"
        >
          <ui-icon
            class="header__icon"
            type="round"
            size="18"
          >
            playlist_add_check
          </ui-icon>
          <span>Job List</span>
        </NuxtLink>
      </li>
      <li
        class="header__item"
        v-if="!isUserManageOnly"
      >
        <NuxtLink
          class="header__link"
          to="/staged"
          :active-class="mobileLinkActiveClass"
          @click="closeMenu()"
          data-testid="stage-nav-item"
        >
          <ui-icon
            class="header__icon"
            type="round"
            size="18"
          >
            collections_bookmark
          </ui-icon>
          <span class="tw-relative">
            Stage
            <span
              class="badge tw-absolute -tw-right-1 -tw-top-7"
              v-if="stagedJobsStore?.pagination?.totalElements > 0"
            >
              {{ stagedJobsStore.pagination.totalElements }}
            </span>
          </span>
        </NuxtLink>
      </li>
      <li class="header__item">
        <NuxtLink
          class="header__link"
          :class="{ header__selected: $route.path.startsWith('/manage-jobs') }"
          to="/manage-jobs/active"
          @click="closeMenu()"
          data-testid="manage-nav-item"
        >
          <ui-icon
            class="header__icon"
            type="round"
            size="18"
          >
            edit
          </ui-icon>
          <span>Manage</span>
        </NuxtLink>
      </li>
      <li class="header__item">
        <button
          @click="toggleMenu()"
          class="header__link tw-border-0 tw-bg-transparent"
          :class="[isMenuOpen && 'header__selected']"
          data-testid="menu-nav-item"
          type="button"
        >
          <ui-icon
            class="header__icon"
            type="round"
            size="18"
          >
            menu
          </ui-icon>
          <span>Menu</span>
        </button>
      </li>
    </ul>
    <div
      class="header__body"
      v-if="isMenuOpen"
      data-testid="menu-body"
    >
      <HeaderMobile />
    </div>
  </div>
</template>

<script setup>
import { useStagedJobsStore } from '@/stores/useStagedJobs';
import useIsUserManageOnly from '@/composables/useIsUserManageOnly';

const stagedJobsStore = useStagedJobsStore();
const { isUserManageOnly } = useIsUserManageOnly();

const isMenuOpen = ref(false);

const mobileLinkActiveClass = computed(() => {
  if (isMenuOpen.value) {
    return '';
  }
  return 'header__selected';
});

const toggleMenu = () => {
  isMenuOpen.value = !isMenuOpen.value;

  if (isMenuOpen.value) {
    useMixpanelTrack('lb2 profile mobile menu clicked');
  }
};

const closeMenu = () => {
  isMenuOpen.value = false;
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/badge.scss';
.header__mobile {
  .header__menu {
    @apply tw-fixed tw-bottom-0 tw-z-20 tw-flex tw-w-full tw-list-none tw-flex-row tw-justify-around tw-border-x-0 tw-border-b-0 tw-border-solid tw-border-border-base tw-bg-grey-light-x tw-pt-2;

    border-top: 1px;
  }

  .header__item {
    @apply tw-pb-2 tw-font-regular tw-text-text-secondary;

    > a {
      color: unset;
      text-decoration: unset;
    }

    .header__icon {
      @apply tw-mt-1;
    }
  }

  .header__link {
    @apply tw-inline-flex tw-flex-col tw-items-center tw-justify-end tw-font-sans tw-text-text-secondary;
    letter-spacing: 0.4px;

    &.header__selected {
      span {
        @apply tw-font-medium;
      }

      .header__icon {
        @apply tw-text-primary-base;
      }
    }
  }

  .header__body {
    @apply tw-fixed tw-top-0 tw-z-50 tw-w-full tw-overflow-scroll tw-bg-secondary-light-xx;
    height: calc(100% - 57px);
  }

  :deep() {
    .tooltip {
      top: -65px;
      width: 95%;
      left: 16px;
    }

    .tooltip::after {
      top: 100%;
      left: 90%;
      border-color: theme('colors.informational.dark') transparent transparent transparent;
    }
  }
}
</style>
